import { Button } from 'components/buttons'
import { initialStateMenu } from 'components/dynamicTab'
import { Icons } from 'interfaces'
import React, { FC } from 'react'
import { useFieldArray } from 'react-hook-form'
import { ElementItemMenu } from './ElementItemMenu'
import { MenuTabItemProps } from './menuTabItem.type'

export const MenuTabItem: FC<MenuTabItemProps> = (props): JSX.Element => {
	const {
		active,
		errors,
		control,
		fieldError,
		isValid,
		register,
		setValue,
		watch,
		setErrorForm,
		setFieldError,
		saveData
	} = props

	const { fields, append, remove } = useFieldArray({
		control,
		name: `tabs.${active}.setup_menu`
	})

	return (
		<div>
			{fields.map((field, index) => {
				return (
					<div key={`menu-${field.id}`}>
						<ElementItemMenu
							active={active}
							menuIndex={index}
							register={register}
							errors={errors}
							setValue={setValue}
							watch={watch}
							control={control}
							saveData={saveData}
							setFieldError={setFieldError}
							setErrorForm={setErrorForm}
							isValid={isValid}
							fieldError={fieldError}
							remove={remove}
						/>
					</div>
				)
			})}
			<div
				aria-hidden="true"
				className="flex  min-w-[100px] justify-center items-center"
			>
				<Button
					label="Add Menu"
					className="w-full md:w-auto my-2"
					iconRight={Icons.plus}
					color="white"
					onClick={() => {
						const maxOrder = Math.max(
							...fields.map(c => c.section_order as number),
							0
						)
						append({ ...initialStateMenu, section_order: maxOrder + 1 })
					}}
				/>
			</div>
		</div>
	)
}
